export const DEMAND_SPECIFIC_CREATE_REQUEST = 'DEMAND_SPECIFIC_CREATE_REQUEST';
export const DEMAND_SPECIFIC_CREATE_SUCCESS = 'DEMAND_SPECIFIC_CREATE_SUCCESS';
export const DEMAND_SPECIFIC_CREATE_FAIL = 'DEMAND_SPECIFIC_CREATE_FAIL';
export const DEMAND_SPECIFIC_CREATE_RESET = 'DEMAND_SPECIFIC_CREATE_RESET';

export const DEMAND_SPECIFIC_DOWNLOAD_REQUEST = 'DEMAND_SPECIFIC_DOWNLOAD_REQUEST';
export const DEMAND_SPECIFIC_DOWNLOAD_SUCCESS = 'DEMAND_SPECIFIC_DOWNLOAD_SUCCESS';
export const DEMAND_SPECIFIC_DOWNLOAD_FAIL = 'DEMAND_SPECIFIC_DOWNLOAD_FAIL';
export const DEMAND_SPECIFIC_DOWNLOAD_RESET = 'DEMAND_SPECIFIC_DOWNLOAD_RESET';


export const DEMAND_SPECIFIC_BATCH_REQUEST = 'DEMAND_SPECIFIC_BATCH_REQUEST';
export const DEMAND_SPECIFIC_BATCH_SUCCESS = 'DEMAND_SPECIFIC_BATCH_SUCCESS';
export const DEMAND_SPECIFIC_BATCH_FAIL = 'DEMAND_SPECIFIC_BATCH_FAIL';
export const DEMAND_SPECIFIC_BATCH_RESET = 'DEMAND_SPECIFIC_BATCH_RESET';

export const DEMAND_SPECIFIC_LIST_REQUEST = 'DEMAND_SPECIFIC_LIST_REQUEST';
export const DEMAND_SPECIFIC_LIST_SUCCESS = 'DEMAND_SPECIFIC_LIST_SUCCESS';
export const DEMAND_SPECIFIC_LIST_FAIL = 'DEMAND_SPECIFIC_LIST_FAIL';
export const DEMAND_SPECIFIC_LIST_RESET = 'DEMAND_SPECIFIC_LIST_RESET';

export const DEMAND_SPECIFIC_EXCEL_EXPORT_REQUEST = 'DEMAND_SPECIFIC_EXCEL_EXPORT_REQUEST';
export const DEMAND_SPECIFIC_EXCEL_EXPORT_SUCCESS = 'DEMAND_SPECIFIC_EXCEL_EXPORT_SUCCESS';
export const DEMAND_SPECIFIC_EXCEL_EXPORT_FAIL = 'DEMAND_SPECIFIC_EXCEL_EXPORT_FAIL';
export const DEMAND_SPECIFIC_EXCEL_EXPORT_RESET = 'DEMAND_SPECIFIC_EXCEL_EXPORT_RESET';